import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StudentClassesViewmodel } from 'edu-application/dist/classes/get-student-classes/get-student-classes.viewmodel';
import { ClassPickerDialogComponent } from './class-picker-dialog.component';

@Injectable({ providedIn: 'root' })
export class ClassPickerService {
  private _ref: MatDialogRef<ClassPickerDialogComponent> | null = null;

  constructor(private dialog: MatDialog) {}

  open(required = false): Promise<StudentClassesViewmodel | null> {
    if (this._ref) {
      return Promise.resolve(null);
    }
    this._ref = this.dialog.open(ClassPickerDialogComponent, {
      width: 'min(860px, 96vw)',
      maxHeight: '90vh',
      panelClass: 'class-picker-panel',
      backdropClass: required ? ['class-picker-backdrop', 'class-picker-backdrop--required'] : 'class-picker-backdrop',
      disableClose: required,
      autoFocus: false,
      data: { required },
    });
    return new Promise((resolve) => {
      this._ref!.afterClosed().subscribe((result) => {
        this._ref = null;
        resolve(result ?? null);
      });
    });
  }
}
